// extracted by mini-css-extract-plugin
export var brand = "_6g-9";
export var compact = "_6g-6";
export var extraSmall = "_6g-7";
export var icon = "_6g-0";
export var large = "_6g-4";
export var light = "_6g-1";
export var medium = "_6g-5";
export var outline = "_6g-b";
export var primaryDark = "_6g-a";
export var primaryLight = "_6g-8";
export var primaryModern = "_6g-c";
export var success = "_6g-2";
export var successSolid = "_6g-3";